export const ROOM_COLOR_MAPPING = {
  PM: '#00589B',
  UX: '#CF5C78',
  RD: '#00A0B0',
  QA: '#AFA4CE',
  PANTRY: '#939597',
  MEETING: '#CFC482',
};

export const GRID_STROKE_WIDTH = 0.5;
export const GRID_UNIT_PX = 20;

export const PACKET_CONFIG = {
  RADIUS: 5,
  COLOR: {
    BUG: '#F26B5B',
    FIX: '#BFD833',
    DEFAULT: '#363B48',
  },
};

export const ROOM_CONFIG = {
  PANTRY: {
    WIDTH: 3,
    HEIGHT: 2,
  },
  MEETING: {
    WIDTH: 2,
    HEIGHT: 4,
  },
};

export const TYPE_PRODUCT = 'PRODUCT';
export const TYPE_TEAMS = {
  PM: 'PM',
  UX: 'UX',
  RD: 'RD',
  QA: 'QA',
  PANTRY: 'PANTRY',
  MEETING: 'MEETING',
};

export const EMPLOYEE_ACTIVITY_COLOR = {
  DEFAULT: '#fff',
  TakeTask: '#81CC45',
  PlaceTask: '#81CC45',
  ProcessTask: '#F5DF4D',
  DrinkCoffee: '#7C4C53',
  Meeting: '#BA5B3F',
};

export const TICK_INTERVAL = 200;
export const PRODUCT_COUNT = 2;
